// Mock 数据入口
// 模拟 API 响应延迟
const delay = (ms: number = 300) => new Promise((resolve) => setTimeout(resolve, ms))

// 通用成功响应
const success = (data: unknown) => ({
  code: 0,
  data,
  message: 'success',
})

// 通用错误响应
const error = (message: string, code: number = 1) => ({
  code,
  data: null,
  message,
})

// Mock 处理器类型
type MockHandler = (config: { data?: unknown; params?: unknown }) => Promise<unknown>

// 导出所有 mock 处理器
export const mockHandlers: Record<string, MockHandler> = {
  // 用户相关 Mock
  '/api/user/info': async () => {
    await delay()
    return success({
      id: 1,
      name: '张三',
      phone: '13800138000',
      department: '技术部',
      position: '前端工程师',
      avatar: 'https://picsum.photos/100/100',
    })
  },

  '/api/user/login': async (config) => {
    await delay()
    // 模拟登录验证
    const { phone, password } = config.data as { phone: string; password: string }
    if (phone === '13800138000' && password === '123456') {
      return success({
        token: 'mock-token-xxx-xxx',
        userInfo: {
          id: 1,
          name: '张三',
          phone: '13800138000',
        },
      })
    }
    return error('账号或密码错误')
  },

  // 订单相关 Mock
  '/api/order/list': async (config) => {
    await delay()
    const { page = 1, pageSize = 10 } = config.params as { page?: number; pageSize?: number }
    return success({
      list: Array.from({ length: pageSize }, (_, i) => ({
        id: page * 10 + i,
        orderNo: `ORD${Date.now()}${i}`,
        amount: Math.floor(Math.random() * 10000),
        status: ['pending', 'completed', 'cancelled'][Math.floor(Math.random() * 3)],
        createTime: new Date().toISOString(),
      })),
      total: 100,
      page,
      pageSize,
    })
  },
}

export default mockHandlers
